import { render, staticRenderFns } from "./MovePhraseDialog.vue?vue&type=template&id=0175370c&scoped=true"
import script from "./MovePhraseDialog.vue?vue&type=script&lang=js"
export * from "./MovePhraseDialog.vue?vue&type=script&lang=js"
import style0 from "./MovePhraseDialog.vue?vue&type=style&index=0&id=0175370c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0175370c",
  null
  
)

export default component.exports